<style lang="less">
  // @import '../flow.less';
  @import '../cmdb.less';
</style>

<template>
  <div>
    <Card style="margin-bottom:10px;">
      <Row>
        <i-col :md="18" span="24">
          <Form ref="searchForm" inline :model="searchForm" :label-width="30" @submit.native.prevent>
            <FormItem label="IDC" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入IDC名" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getIdcList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col :md="6" span="24">
          <Button style="float: right;" @click="AddIdc" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加</Button>
        </i-col>
        </Row>

      <!-- <tables search-place="top" v-model="idcList" :columns="columns" @on-sort-change="changeSort"/> -->
      <Drawer
        title="添加"
        v-model="change"
        width="500"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="70" :rules="ruleValidate">
          <form-item label="IDC名称" prop="name">
              <i-input  v-model="formItem.name" placeholder="请输入IDC名称"></i-input>
          </form-item>
          <form-item label="描述" prop="description">
              <i-input  v-model="formItem.description" placeholder="请输入IDC描述"></i-input>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>

        <Drawer
        title="添加"
        v-model="changeJg"
        width="720"
        :mask-closable="true"
        @on-close="drawerCloseJg"
      >
        <i-form ref="formItemJg" :model="formItemJg" :label-width="100" :rules="ruleValidateJg">
          <form-item label="机柜名称" prop="name">
              <i-input  v-model="formItemJg.name" placeholder="请输入机柜名称"></i-input>
          </form-item>
          <form-item label="机柜高度" prop="row_height">
              <InputNumber :max="50" :min="1" v-model="formItemJg.row_height"></InputNumber>
          </form-item>
          <form-item label="IDC" prop="idc">
              <i-select v-model="formItemJg.idc"  style="width: 90%;">
              <i-option v-for="item in idcList" :value="item.id" :key="item.id" :label="item.name"></i-option>
              </i-select>
          </form-item>
          <form-item label="描述" prop="description">
              <i-input  v-model="formItemJg.description" placeholder="请输入机柜描述"></i-input>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmitJg('formItemJg')">提交</i-button>
            <i-button style="margin-left: 8px" @click="changeJg=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
    <Card :bordered="false">
        <Row style="margin: 10px;" class="idc-item-list">
        <i-col v-for="item in idcList" :key="item.id" :sm="12" :md="8" :lg="6" span="24">
                <div @click="cabinetHasHostFlag(item.cabinet_set, item.id)">
                <div class="idc-item" >
                    <div class="header">
                        <div class="name">
                            <h4>{{ item.name }}</h4>
                        </div>
                    </div>
                    <div class="img">
                        <img :src="idcPic" />
                    </div>
                    <div class="info">
                        <div class="row">
                            <span class="config">
                                设备总数
                            </span>
                            <span class="config-value">{{ item.host_count }}</span>
                        </div>
                        <div class="row">
                            <span class="config">
                                告警设备数
                            </span>
                            <span class="config-value">0</span>
                        </div>
                        <div class="row">
                            <span class="config">
                                告警总数
                            </span>
                            <span class="config-value">0</span>
                        </div>
                        <div class="row">
                            <span class="config">
                                确认告警数
                            </span>
                            <span class="config-value">0</span>
                        </div>
                    </div>
                </div>
                </div>
        </i-col>
      </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import idcPic from '@/assets/images/idc/idc.jpg'
import { getIdcList, saveIdc, saveJg } from '@/api/idc'
export default {
  name: 'IdcList',
  components: {
    Tables
  },
  data () {
    return {
      idcPic,
      count: 1,
      size: 10,
      page: 1,
      change: false,
      changeJg: false,
      ordering: null,
      idcList: [],
      user_all: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        name: '',
        description: ''
      },
      formItemJg: {
        name: '',
        row_height: 42,
        idc: null,
        description: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [{ required: true, message: 'IDC名称不能为空 !', trigger: 'blur' }]
      },
      ruleValidateJg: {
        name: [{ required: true, message: '机柜名称不能为空 !', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getIdcList () {
      // this.idcList = [{'id': 1, 'name': '深圳机房1', 'account': null, 'account_id': null, 'bandwidth': null, 'host_count': 3, 'linkman': null, 'phone': null, 'address': null, 'date_added': '2018-10-13', 'deleted': false, 'description': null, 'type': '0', 'cabinet_set': []}, {'id': 2, 'name': '深圳机房1', 'account': null, 'account_id': null, 'bandwidth': null, 'host_count': 3, 'linkman': null, 'phone': null, 'address': null, 'date_added': '2018-10-13', 'deleted': false, 'description': null, 'type': '0', 'cabinet_set': [{'id': 1, 'name': '机柜1', 'idc': 1, 'row_height': '42', 'description': '', 'deleted': false, 'host_cabinet': [{'id': 2, 'name': '10.1.2.176', 'idc': '深圳机房1', 'description': null, 'address_start': '6', 'address_end': '8', 'cabinet': 1, 'alarm_level': '1', 'ip_main': '10.1.2.176', 'category': '虚拟机', 'cage_direction': 'X', 'cage_num': null}]}]}]
      let params = {
        search: this.searchForm.name
      }
      getIdcList(params).then(res => {
        this.idcList = res.data
      })
    },
    cabinetHasHostFlag (cabinetSet, id) {
      if (cabinetSet.length > 0) {
        this.$router.push({name: 'CabinetList', query: {id: id}})
      } else {
        this.$Modal.confirm({
          width: 300,
          title: '无机柜信息',
          content: '<p>是否添加当前机房的机柜信息</p>',
          onOk: () => {
            this.AddJg(id)
          }
        })
      }
    },
    AddIdc () {
      let that = this.formItem
      this.change = true
      that.name = ''
      that.description = ''
    },
    AddJg (id) {
      let that = this.formItemJg
      this.changeJg = true
      that.name = ''
      that.idc = id
      that.rowHeight = 42
      that.description = ''
    },
    deleteUser (id) {
      deleteIdc(id).then(res => {
        if (res.data.code === 200) {
          this.$Message.success(res.data.msg)
          this.getIdcList()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.name = ''
      that.description = ''
    },
    drawerCloseJg () {
      let that = this.formItemJg
      that.name = ''
      that.description = ''
    },
    searchReset () {
      this.searchForm.name = null
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          saveIdc(this.formItem).then(res => {
            if (res.data.id > 0) {
              this.change = false
              this.getIdcList()
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    },
    handleSubmitJg (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          saveJg(this.formItemJg).then(res => {
            if (res.data.id > 0) {
              this.changeJg = false
              this.getIdcList()
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data.msg)
            }
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.getIdcList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
